import React from 'react';

const About = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>About LitDiversity</h2>
      <p>
        LitDiversity emerges as a beacon of inclusivity and exploration in literature for K-12 students, set against the backdrop of increasing book bans and censorship in American schools. Our dual-purpose mission is to equip educators with a repository of diverse books for their curriculum and to empower students to discover and track books.
      </p>
      <p>
        With an expansive selection of titles, LitDiversity aims to create an environment where every student can see themselves in the stories they read and learn about the world through the eyes of others. We believe in the power of literature to foster empathy, understanding, and a passion for reading, by showcasing the diverse tapestry of human experience.
      </p>
      <p>
        For educators, LitDiversity offers tools to seamlessly integrate diverse narratives into teaching materials. For students, it's a gateway to finding stories that resonate personally and academically, encouraging independent reading and exploration. 
      </p>
    </div>
  );
};

export default About;
